import { intboolean } from "app/types/app-types"
import Shape from "./shape"

export type PathType = 'C' | 'S' | 'A' | 'M' | 'L' | 'Z' | 'V' | 'H' | 'T' | 'Q'   //path type (curve, arc, line, ....)

export type PathPoint = {
    t?: PathType
    x: number
    y: number
    cx?: number
    cy?: number
    cx2?: number
    cy2?: number
    xRotDegrees?: number
    isLargeArc?: intboolean
    isSweep?: intboolean
    
}

export const AllPathTypes: PathType[] = ['C', 'S', 'A', 'M', 'L', 'Z', 'V', 'H', 'T', 'Q']
export const AllPathTypesAndMeanings = {
    C: 'Cubic Bézier',
    S: 'Bézier Smooth',
    A: 'Arc',
    M: 'Move',
    L: 'Line',
    Z: 'Close Path',
    V: 'Vertical Line',
    H: 'Horizontal Line',
    Q: 'Quadratic Bézier',
    T: 'Quadratic Bézier Smooth'
}

interface PathShape extends Shape {
    type: "bezier"
    points: PathPoint[]
}

export default PathShape